import React from 'react'
import {Navigate, Outlet } from 'react-router-dom'
import { getToken } from './Common'

const PublicRoute = ({ component: Component, ...rest}) => {
    return !getToken() ? <Outlet /> : <Navigate to="/" />
}

export default PublicRoute
